<template>
  <div class="right-menu">
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <div class="index-help" @click.stop>
          <div
            style="display: flex;align-items: center;height: 60px;overflow: hidden;"
          >
            <span style="font-size: 20px;">主页</span>
            <router-link :to="{ path: '/' }"
              ><el-button
                size="small"
                style="font-size: 140%;"
                icon="el-icon-s-home"
                circle
              ></el-button
            ></router-link>
          </div>
          <div
            style="display: flex;align-items: center;"
            @click="$router.push('/assistant/viewAssistant')"
          >
            <span style="font-size: 20px;">帮助</span>
            <el-button
              size="small"
              style="font-size: 140%;"
              icon="el-icon-question"
              circle
            ></el-button>
          </div>
          <div style="display: flex;align-items: center;">
            <span style="font-size: 20px;">护眼</span>
            <el-popover placement="top" min-width="250" v-model="visible">
              <div
                style="display: flex;justify-content: space-around;align-items: center;"
              >
                <div
                  v-for="(item, index) in colorList"
                  :style="{ backgroundColor: item }"
                  class="baseColor"
                  @click="$store.state.user.baseColor = item"
                >
                  {{ colorName[index] }}
                </div>
              </div>
              <el-button
                size="small"
                slot="reference"
                icon="el-icon-view"
                :style="{
                  color:
                    $store.state.user.baseColor == '#FFFFFF'
                      ? ''
                      : $store.state.user.baseColor,
                  fontSize: '140%'
                }"
                circle
              ></el-button>
            </el-popover>
          </div>
          <div
            style="display: flex;align-items: center;"
            @click="onDownloadApp"
          >
            <span style="font-size: 20px;">手机扫码下载</span>
            <el-button
              size="small"
              slot="reference"
              icon="el-icon-mobile-phone"
              :style="{
                fontSize: '140%'
              }"
              circle
            ></el-button>
          </div>
        </div>
        <div class="user-avatar">
          <!-- <img :src="avatar+'?imageView2/1/w/80/h/80'" style="width: 100%;"> -->
          <!-- <i class="el-icon-picture"></i> -->
          <div class="avatar">{{ name }}</div>
        </div>
        <div
          style="color: #888888;z-index: 999;height: 50px;display: flex;flex-direction: column;align-items: center;justify-content: center;"
        >
          <div
            style="cursor: pointer;line-height: 20px;height: 20px;width: 100%;color: #818181;overflow: hidden;"
          >
            {{ name }}
          </div>
          <div
            style="cursor: pointer;line-height: 20px;height: 20px;width: 100%;"
          >
            {{ org }}
          </div>
        </div>
        <i class="el-icon-caret-bottom" />
      </div>
      <el-dropdown-menu slot="dropdown" class="user-dropdown">
        <router-link to="/">
          <el-dropdown-item>
            主页
            <router-link to="/index"></router-link>
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item
          divided
          @click.native="$router.push('/meta/page/viewAttr')"
        >
          <span style="display:block;">个人档案</span>
        </el-dropdown-item>
        <el-dropdown-item divided @click.native="pwdModel = true">
          <span style="display:block;">密码修改</span>
        </el-dropdown-item>
        <el-dropdown-item divided @click.native="toggleRole">
          <span style="display:block;">角色切换</span>
        </el-dropdown-item>
        <el-dropdown-item divided @click.native="logout">
          <span style="display:block;">退出登录</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-drawer
      title="密码变更"
      :visible.sync="pwdModel"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="150px"
        inline-message
        :rules="rules"
      >
        <el-form-item label="旧密码" prop="oldPwd">
          <el-input
            v-model="form.oldPwd"
            :type="type"
            style="width: 250px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input
            v-model="form.newPwd"
            :type="type"
            style="width: 250px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPwd">
          <el-input
            v-model="form.confirmPwd"
            :type="type"
            style="width: 250px;"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-s-promotion"
            @click="passwordUpdate"
            >提交</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-view"
            @mouseover.native="type = 'text'"
            @mouseout.native="type = 'password'"
            >查看密码</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-drawer
      title="角色切换"
      size="300px"
      :visible.sync="roleModel"
      direction="rtl"
    >
      <div style="padding: 20px;display: flex;flex-direction: column;">
        <el-button
          style="margin: 10px;"
          @click="handleRole(item)"
          :type="currentRole == item.roleId ? 'primary' : ''"
          v-for="(item, index) in roleData"
          :key="index"
          >{{ dict_role[item.roleId % 14] }}</el-button
        >
      </div>
    </el-drawer>
    <vxe-modal v-model="open" width="600" height="600">
      <template v-slot>
        <div id="qrcode" ref="qrcode"></div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { mapGetters } from "vuex";
import { setToken } from "@/utils/auth";
import {
  passwordChange,
  getRole4currentUser,
  changeRole
} from "@/api/person.js";
import getDefaultState from "@/store/modules/user.js";

export default {
  computed: {
    ...mapGetters(["avatar", "name", "org"]),
    baseColor() {
      return this.$store.state.user.baseColor;
    }
  },
  watch: {
    baseColor(val) {
      window.localStorage.setItem("baseColor", val);
    }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else {
        if (this.form.confirmPwd !== "") {
          this.$refs.form.validateField("confirmPwd");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.newPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      open: false,
      type: "password",
      form: {
        oldPwd: "",
        newPwd: "",
        confirmPwd: ""
      },
      pwdModel: false,
      rules: {
        oldPwd: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
        newPwd: [{ validator: validatePass, trigger: "blur" }],
        confirmPwd: [{ validator: validatePass2, trigger: "blur" }]
      },
      dict_role: getDefaultState.state.dict_role,
      roleModel: false,
      roleData: [],
      currentRole: window.localStorage.getItem("roleId"),
      visible: false,
      colorList: [
        "#FFFFFF",
        "rgb(193, 230, 198)",
        "RGB(250, 249, 222)",
        "RGB(255, 242, 226)",
        "RGB(253, 230, 224)",
        "RGB(227, 237, 205)",
        "RGB(220, 226, 241)",
        "RGB(233, 235, 254)",
        "RGB(234, 234, 239)"
      ],
      colorName: [
        "银河白",
        "豆沙绿",
        "杏仁黄",
        "秋叶褐",
        "胭脂红",
        "青草绿",
        "海天蓝",
        "葛巾紫",
        "极光灰"
      ]
    };
  },
  methods: {
    close() {
      this.open = false;
    },

    onDownloadApp() {
      this.open = true;
      setTimeout(() => {
        this.qrcode();
      }, 200);
    },

    qrcode() {
      //清除上一张二维码缓存
      this.$refs.qrcode.innerHTML = "";
      // 生成二维码
      let port = window.location.port;
      let port_name = {
        "14401":
          "http://39.108.61.54:9000/apk/guangdong/%E4%BD%93%E8%82%B2%E4%BA%91.apk",
        "13201":
          "http://39.108.61.54:9000/apk/jiangsu/%E4%BD%93%E8%82%B2%E4%BA%91.apk",
        "11601":
          "http://39.108.61.54:9000/apk/zonghe/%E4%BD%93%E8%82%B2%E4%BA%91.apk", //综合
        "11101":
          "http://39.108.61.54:9000/apk/beijing/%E4%BD%93%E8%82%B2%E4%BA%91.apk",
        "11501":
          "http://39.108.61.54:9000/apk/menggu/%E4%BD%93%E8%82%B2%E4%BA%91.apk", //内蒙
        "11301":
          "http://39.108.61.54:9000/apk/hebei/%E4%BD%93%E8%82%B2%E4%BA%91.apk",
        "14101":
          "http://39.108.61.54:9000/apk/henan/%E4%BD%93%E8%82%B2%E4%BA%91.apk", //河南
        "12301":
          "http://39.108.61.54:9000/apk/henan/%E4%BD%93%E8%82%B2%E4%BA%91.apk"
      };
      var unixTimestamp = new Date().getTime();
      let apkUrl = port_name[port] + "?" + unixTimestamp;

      let qrcode = new QRCode("qrcode", {
        width: 500, // 二维码宽度，单位像素
        height: 500, // 二维码高度，单位像素
        text: apkUrl // 生成二维码的链接
      });
    },
    handleRole(item) {
      changeRole({ targetRoleId: item.roleId }).then(res => {
        if (res.code === 200) {
          setToken(res.data.token);
          console.log(res, "8888");
          window.localStorage.setItem("roleId", res.data.roleId);
          window.sessionStorage.setItem("roleId", res.data.roleId);
          window.localStorage.setItem("userId", res.data.userId);
          window.sessionStorage.setItem("userId", res.data.userId);
          window.sessionStorage.setItem("orgId", res.data.orgId);
          this.$store
            .dispatch("user/getMenu", {
              userId: res.data.userId,
              roleId: res.data.roleId
            })
            .then(res => {
              window.location.reload();
            });
        }
      });
    },
    toggleRole() {
      getRole4currentUser().then(res => {
        if (res.code === 200 && res.data.length != 0) {
          this.roleData = res.data;
        } else {
          this.$message.warning("没有可用权限！");
          this.roleData = [];
        }
      });
      this.roleModel = true;
    },
    passwordUpdate() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let data = {
            old: this.form.oldPwd,
            newP: this.form.newPwd,
            confirm: this.form.confirmPwd
          };
          passwordChange(data).then(res => {
            if (res.code === 200) {
              this.$message.success(res.data);
            } else {
              this.$message.error(res.data);
            }
          });
        } else {
          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    async logout() {
      await this.$store.dispatch("user/logout");
      this.$router.push(`/login`);
    }
  }
};
</script>

<style lang="scss" scoped>
.baseColor {
  height: 50px;
  width: 50px;
  border: 1px solid #cccccc;
  cursor: pointer;
  text-align: center;
  line-height: 50px;
  font-size: 90%;
}

.right-menu {
  float: right;
  height: 100%;

  &:focus {
    outline: none;
  }

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  .avatar-container {
    margin-right: 30px;

    .avatar-wrapper {
      height: 50px;
      margin-top: 5px;
      position: relative;
      display: flex;
      align-items: center;
      font-size: 80%;

      .index-help {
        display: flex;
        align-items: center;
        justify-content: center;
        float: right;
        border-right: 1px solid #eeeeee;
        margin-right: 10px;

        div {
          margin-right: 10px;
        }
      }

      .user-avatar {
        cursor: pointer;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        background-color: #eeeeee;
        text-align: center;
        line-height: 35px;
        margin-right: 15px;
        overflow: hidden;

        .avatar {
          font-size: 18px;
          animation-name: nameAvatar;
          animation-duration: 15s;
          animation-timing-function: linear;
          animation-fill-mode: forwards;
          animation-iteration-count: infinite;
        }
      }

      @keyframes nameAvatar {
        0% {
          transform: translateX(1px);
        }

        50% {
          transform: translateX(-150px);
        }

        100% {
          transform: translateX(1px);
        }
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>
